import { Button, Card, Stack, Typography } from "@mui/material";
import QuestionsGeneratingLogs from "components/QuestionsGeneratingLogs";
import PlusIcon from "assets/icons/PlusIcon";
import { Link } from "react-router-dom";
import { Dispatch, SetStateAction, useMemo } from "react";
import { CompetencyMapQuery } from "@generated/graphql";
import ROUTES from "constants/routes";
import qs from "qs";
import Info from "../../components/Info";
import { SkillOption } from "../../components/types";
import { ConstructorTabProps } from "./types";

type SkillsMap = Record<string, Omit<SkillOption, "id">>;

const extractSkills = (competencyMap: CompetencyMapQuery["competencyMap"]): SkillsMap => {
  if (!competencyMap?.competences) return {};

  const skillsEntries = competencyMap.competences.flatMap((competence) => {
    const knowledgeBlocks = competence.knowledgeBlockCompetences || [];

    return knowledgeBlocks.flatMap((knowledgeBlock) => {
      const skills = knowledgeBlock.knowledgeBlock?.skills || [];
      return skills.map(({ id, title }) => [id, { title }]);
    });
  });

  return Object.fromEntries(skillsEntries);
};

interface RightColumnProps extends Omit<ConstructorTabProps, "fieldArray"> {
  setOpenCopyModal: Dispatch<SetStateAction<boolean>>;
}

const RightColumn = ({
  form,
  isEditable,
  setOpenCopyModal,
  competencyMap,
  competencyMapGenQuestionsLogs,
  refetchCompetencyMapGenQuestionsLog,
  refetchCompetencyMap,
  disabled,
  setIsEditable,
  handleArchiveMap,
  handleUpdateMapStatus,
}: RightColumnProps) => {
  const handleCopyMap = () => {
    setOpenCopyModal(true);
  };

  const originalCompetencyMap = competencyMap?.originalCompetencyMap;

  const skills = extractSkills(competencyMap);

  const extendedLogs = useMemo(
    () =>
      competencyMapGenQuestionsLogs?.map((log) => ({
        ...log,
        skillTitle: log.skillId ? skills[log.skillId]?.title || "" : "",
      })),
    [competencyMapGenQuestionsLogs]
  );

  return (
    <Stack
      spacing={1}
      sx={{ marginTop: -5.5 }}>
      <QuestionsGeneratingLogs
        logs={extendedLogs}
        refetchLogs={refetchCompetencyMapGenQuestionsLog}
        afterRefetchLogs={refetchCompetencyMap}
      />
      <Info
        competencyMap={competencyMap}
        form={form}
        disabled={disabled}
        isEditable={isEditable}
        setIsEditable={setIsEditable}
        handleUpdateMapStatus={handleUpdateMapStatus}
        handleArchiveMap={handleArchiveMap}
      />
      <Button
        startIcon={<PlusIcon sx={{ width: 16, height: 16 }} />}
        sx={({ typography }) => ({
          px: 0,
          justifyContent: "flex-end",
          color: "base.200",
          ...typography.body14rg,
        })}
        color='primary'
        onClick={handleCopyMap}>
        дублировать карту
      </Button>
      {originalCompetencyMap && (
        <Card>
          <Typography variant='body16rg'>
            Является дубликатом карты{" "}
            <Link
              to={{
                pathname: `/${ROUTES.COMPETENCE_MAPS}/view/${originalCompetencyMap.id}`,
                search: qs.stringify({ redirectCompetencyMapId: competencyMap.id }),
              }}>
              {originalCompetencyMap.title}
            </Link>
          </Typography>
        </Card>
      )}
    </Stack>
  );
};

export default RightColumn;
